import { configureStore } from '@reduxjs/toolkit';
import profileReducer from './Reducer/ProfileReducer';

const store = configureStore({
  reducer: {
    profile: profileReducer,
  },
});

export default store;
